/**
 * @fileoverview GET handler for the "/engagement/link_aliases/upsert_lid" endpoint
 */
import fetch from "@lib/fetch";

import type { LinkAliasMarkupDataResponse } from "../engagementLinkAliases";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLinkAliasesUpsertLid } from "./constants";
import type { GetEngagementLinkAliasesUpsertLidProps } from "./types";
import { isLinkAliasMarkupDataResponse } from "./validators";

export const getEngagementLinkAliasesUpsertLid = reactQueryFetcherAdapter(
  engagementLinkAliasesUpsertLid,
  (
    signal: AbortSignal,
    {
      campaignId,
      messageVariationId,
      contentBlockId,
      dndJson,
      html,
      links,
      draftCbMappings,
      linkIncluderSequenceBase,
      linkIncluderSequenceOffset,
      contentBlockInclusionSequenceBase,
      contentBlockInclusionSequenceOffset,
      trackedLinkCount,
    }: GetEngagementLinkAliasesUpsertLidProps
  ): Promise<LinkAliasMarkupDataResponse> => {
    return fetch(
      "/engagement/link_aliases/upsert_lid",
      // this is intentionally POST - we are leveraging the caching and declarative nature of tanstack query
      // for an endpoint that is only POST because of the need to send large bodies to the server
      "POST",
      {
        campaign_id: campaignId,
        message_variation_id: messageVariationId,
        content_block_id: contentBlockId,
        dnd_json: dndJson,
        html,
        links,
        draft_cb_mappings: draftCbMappings,
        link_includer_sequence_base: linkIncluderSequenceBase,
        link_includer_sequence_offset: linkIncluderSequenceOffset,
        content_block_inclusion_sequence_base: contentBlockInclusionSequenceBase,
        content_block_inclusion_sequence_offset: contentBlockInclusionSequenceOffset,
        tracked_link_count: trackedLinkCount,
      },
      { signal }
    );
  },
  isLinkAliasMarkupDataResponse
);
